module.exports = __webpack_public_path__ + "img/Architetto5.ffd383aa.jpg";